import FormItemUtil from './FormItemUtil';

export default class FormResourceUtil
{
	static getCommandArgMethodInfo(methodName,menuItemId,formId)
	{
		if(!menuItemId)menuItemId = window.menuItemId; if(!formId)formId = window.formId;
		var _key = FormItemUtil.getFormStoresKey(menuItemId,formId);
		var methods = null;
		try
		{
			methods = window.parent.window[_key].listRemoteMethods; 
		}
		catch(e)
		{
			methods = window[_key]?window[_key].listRemoteMethods:null;
		}
		if(!methods || !methodName)
			return null;
		
		for(var i=0;i<methods.length;i++)
		{
			var mi = methods[i];
			if(mi.methodName==methodName)
				return mi;
		}
		
		return null;
	}

	static getEditorPromptArray(key)
	{
		var parentWindow = window.parent.window;
		if(!parentWindow.editorPromptCache)
		{
			parentWindow.editorPromptCache = {};
		}
		if(parentWindow.editorPromptCache[key] == null)
			parentWindow.editorPromptCache[key] = [];
		return parentWindow.editorPromptCache[key];
	}
}


// WEBPACK FOOTER //
// ./src/utils/FormResourceUtil.js